import { REACT_APP_API, REACT_APP_API_SF, REACT_APP_PERITADOR_API } from '../../../common/config'
import { toast } from 'react-toastify'

export const DATAMASTER_ENDPOINT = REACT_APP_API + '/datamasters'
export const CLIENTES_ENDPOINT = REACT_APP_API + '/clients'
export const CATALOGO_ENDPOINT = REACT_APP_API + '/catalogs'
export const FILES_ENDPOINT = REACT_APP_API + '/files/associations'
export const PAYMENT_ENDPOINT = REACT_APP_API + '/pagos'
export const PRESUPUESTOS_ENDPOINT = REACT_APP_API + '/budgets'
export const INTERACTIVE_BUDGETS = REACT_APP_API + '/budgets/interactive'
export const INTERACTIVE_BUDGETS_CATALOG = REACT_APP_API + '/catalogs/interactive-view'
export const ABMS_ENDPOINT = REACT_APP_API + '/abms'
export const STOCKS_ENDPOINT = REACT_APP_API + '/stocks'
export const SALES_ENDPOINT = REACT_APP_API + '/sales'
export const SALES_FILTER_ENDPOINT = REACT_APP_API + '/sales/filter'
export const STATE_STOCK_ENDPOINT = REACT_APP_API + '/stocks/states'
export const SAVINGS_PLAN_ENDPOINT = REACT_APP_API + '/savings-plans'
export const SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT = REACT_APP_API + '/savings-plans-subscriptions'
export const SAVINGS_PLAN_FILTER_ENDPOINT = REACT_APP_API + '/savings-plans/filters'
export const BUDGET_SAVINGS_PLAN_FILTER_ENDPOINT = REACT_APP_API + '/savings-plans-subscriptions/filters'
export const QUOTES_ENDPOINT = REACT_APP_API + '/cotizador/v1'
export const PUBLIC_SHORT_URL = REACT_APP_API + '/public-urls/'
export { REACT_APP_API, REACT_APP_API_SF, REACT_APP_PERITADOR_API }

export const ENDPOINTS_ENUM = {
  PUBLIC_SHORT: 'PUBLIC_SHORT'
}

export function getEndpoint(source) {
  
  switch (source) {
    case 'MAESTRO':
      return DATAMASTER_ENDPOINT
    case 'CLIENTES':
      return CLIENTES_ENDPOINT
    case 'PRODUCTO':
      return CATALOGO_ENDPOINT
    case 'FILES':
      return FILES_ENDPOINT
    case 'PAGOS':
      return PAYMENT_ENDPOINT
    case 'PERITADOR':
      return REACT_APP_PERITADOR_API
    case 'SIMULADOR_FINANCIERO':
      return REACT_APP_API_SF
    case 'PRICING':
      console.log("🚀 ~ file: endpoints.js ~ line 15 ~ getEndpoint ~ source: ", source)
      toast.error('file: endpoints.js ~ line 15 ~ getEndpoint')
      return ''
      // return REACT_APP_PRICING_API
    case 'PRESUPUESTADOR':
      return PRESUPUESTOS_ENDPOINT
    case 'INTERACTIVE_BUDGETS':
      return INTERACTIVE_BUDGETS
    case 'INTERACTIVE_BUDGETS_CATALOG':
      return INTERACTIVE_BUDGETS_CATALOG
    case 'ABMS':
      return ABMS_ENDPOINT
    case 'STOCKS':
      return STOCKS_ENDPOINT
    case 'SALES':
      return SALES_ENDPOINT
    case 'SALES_FILTER':
      return SALES_FILTER_ENDPOINT
    case 'STOCKS_STATES':
      return STATE_STOCK_ENDPOINT
    case 'QUOTES':
      return QUOTES_ENDPOINT
    case 'SAVINGS_PLAN_SUBSCRIPTION':
      return SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT
    case ENDPOINTS_ENUM.PUBLIC_SHORT:
      return PUBLIC_SHORT_URL
    default:
      return null
  }
}
